import React from "react";

class Footer extends React.Component {
  render() {
    return <div className="FooterContainer"></div>;
  }
}

export default Footer;
